.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

@media (width >= 1280px) {
  .grid {
    grid-template-columns: 1fr 1fr;
  }
}

.loading {
  display: block;
  padding: 48px 0;
}

.cardTitle {
  display: flex;
  gap: 16px;
  align-items: baseline;
  justify-content: space-between;
}

.metricName {
  font-size: 16px;
  font-weight: 600;
}

.metricCurrent {
  font-size: 14px;
  font-weight: 500;
  color: var(--ant-color-info);
}

.alert {
  margin-bottom: 12px;
}

.definition {
  padding: 8px 12px;
  margin: 0 0 16px;
  font-size: 13px;
  color: var(--ant-color-text-secondary);
  background: var(--ant-color-fill-alter);
  border-radius: var(--ant-border-radius-sm);
}

.definitionIcon {
  margin-right: 6px;
  color: var(--ant-color-text-tertiary);
}

.chartsRow {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.chartBlock {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.chartTitle {
  font-size: 12px;
  color: var(--ant-color-text-tertiary);
}
